import React from 'react'

import './style.scss'

export const LiteratureBookItem = ({ name }) => {
	return <li className="literature__group-book">{name}</li>
}